import { useEffect } from 'react';

import {
  contentCollectionFormSelector,
  contentCollectionHasAllClipsAutoSubmittedSelector,
  contentCollectionHasClipsSelector,
} from '@air/feature-content-collection/redux';

import { isCypressRun } from '~/utils/PathUtils';
import { useAirStore } from '~/utils/ReduxUtils';

export const useAlertOnUnsubmittedCCForm = () => {
  const store = useAirStore();

  useEffect(() => {
    const handleBeforeunload = (event: BeforeUnloadEvent) => {
      const state = store.getState();
      const form = contentCollectionFormSelector(state);
      const hasClips = contentCollectionHasClipsSelector(state);

      // ignore reload warning on cypress run
      if (isCypressRun()) {
        return;
      }

      if (form.autoSubmit && contentCollectionHasAllClipsAutoSubmittedSelector(state)) {
        return;
      }

      if (hasClips) {
        event.preventDefault();
        // beforeunload requires returning a string if we want to intercept this event.
        // IMPORTANT: this string won't be presented to the user - browser have their own messages, which can't be changed.
        return (event.returnValue =
          'Leave page?\nYour items have not been submitted. Changes you made may not be saved');
      }
    };

    window.addEventListener('beforeunload', handleBeforeunload);

    return () => {
      window.removeEventListener('beforeunload', handleBeforeunload);
    };
  }, [store]);
};
